import { useState, useCallback, useRef } from "react";
import { UserHandlerKey } from "../context/UsersContext";

export const useUserDialog = () => {
  const [dialogHandlerKey, setDialogHandlerKey] =
    useState<UserHandlerKey | null>(null);
  const dialogConfirmCallback = useRef<(() => void) | null>(null);

  const openDialog = useCallback(
    (handlerKey: UserHandlerKey, onConfirm: () => void) => {
      setDialogHandlerKey(handlerKey);
      dialogConfirmCallback.current = onConfirm;
    },
    [],
  );

  const closeDialog = useCallback(() => {
    setDialogHandlerKey(null);
    dialogConfirmCallback.current = null;
  }, []);

  const confirmDialog = useCallback(() => {
    if (dialogConfirmCallback.current) {
      dialogConfirmCallback.current();
    }
  }, []);

  return {
    dialogHandlerKey,
    openDialog,
    closeDialog,
    confirmDialog,
  };
};
